import styled from 'styled-components'

export const Wrapper = styled.div`
    background: linear-gradient(-180deg, #831e62, #be317f);
    min-height: 100%;
`